import { useDocumentosPendientes } from "../hooks/useDocumentosPendientes";
import TablaSoloPendientes from "../components/TablaSoloPendientes";
import { useState } from "react";
import SeleccionarRecibo from "../../recibos/UI/Imputaciones/SeleccionarRecibo";
import { Box, Button, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import RefreshIcon from "@mui/icons-material/Refresh";
import SaldosFacturasModal from "../../facturas/UI/SaldosFacturasModal";
import { FlareSharp } from "@mui/icons-material";
import ReciboDetalleContainer from "../../recibos/UI/MostrarDetalleRecibo/ReciboDetalleContainer";
import ImputacionModal from "../../recibos/UI/Imputaciones/ImputacionModal";

const CuentaCorrientePendientesPage = ({
  idCliente,
  idTipoNegocio,
  onVolver,
  clienteData,
}) => {
  const { documentos, totales, loading, error, refresh } =
    useDocumentosPendientes(idCliente, idTipoNegocio);

  const [showAplicacion, setShowAplicacion] = useState(false);
  const [showInvoiceDetail, setShowInvoiceDetail] = useState(false);
  const [showReceiptDetail, setShowReceiptDetail] = useState(false);
  const [showAplicarReciboAFactura, setShowAplicarReciboAFactura] =
    useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleAplicarRecibo = (rowData) => {
    setShowAplicarReciboAFactura(true);
    const recibo = {
      id: rowData.id,
      fecha_de_pago: rowData.fecha_emision,
      total: rowData.pendiente,
      nro_recibo: rowData.nro_comprobante,
      saldo: rowData.pendiente,
    };
    setSelectedRow(recibo);
  };

  const handleOpenReceiptDetail = (rowData) => {
    setSelectedRow(rowData);
    setShowReceiptDetail(true);
  };
  const handleOpenInvoiceDetail = (rowData) => {
    setSelectedRow(rowData);
    setShowInvoiceDetail(true);
  };

  if (error)
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "50vh",
          gap: 2,
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 56, color: "error.main" }} />
        <Typography variant="h6" fontWeight={600} color="error.main">
          Ocurrió un error al traer los comprobantes pendientes
        </Typography>
        {/* <Typography variant="body2" color="text.secondary">
          {error} Testear como estoy manejando los errores antes de devolver el error
        </Typography> */}
        <Button
          variant="outlined"
          color="error"
          startIcon={<RefreshIcon />}
          onClick={refresh}
          sx={{ borderRadius: 3 }}
        >
          Reintentar
        </Button>
      </Box>
    );

  return (
    <>
      <TablaSoloPendientes
        data={documentos}
        totales={totales}
        onVolver={onVolver}
        loading={loading}
        onAplicarRecibo={() => setShowAplicacion(true)}
        handleOpenInvoiceDetail={handleOpenInvoiceDetail}
        handleOpenReceiptDetail={handleOpenReceiptDetail}
        handleAplicarRecibo={handleAplicarRecibo}
      />
      <SeleccionarRecibo
        open={showAplicacion}
        onClose={() => setShowAplicacion(false)}
        cuit={clienteData?.cuit}
        getDocuments={refresh}
        clienteData={clienteData}
        onSelect={() => {}}
      />
      <SaldosFacturasModal
        open={showInvoiceDetail}
        onClose={() => setShowInvoiceDetail(false)}
        rowInfo={selectedRow}
        clienteData={clienteData}
      />
      <ReciboDetalleContainer
        open={showReceiptDetail}
        onClose={() => setShowReceiptDetail(false)}
        reciboId={selectedRow?.id}
        clienteData={clienteData}
      />
      <ImputacionModal
        open={showAplicarReciboAFactura}
        onClose={() => setShowAplicarReciboAFactura(false)}
        mode="post"
        cuit={clienteData.cuit || ""}
        recibo={selectedRow}
        clienteData={clienteData}
        getDocuments={refresh}
        user={localStorage.getItem("user")}
        saldoDisponible={selectedRow?.saldo}
        // imputaciones={state.imputaciones}
        // onSetImputaciones={setImputaciones}
      />
    </>
  );
};

export default CuentaCorrientePendientesPage;
